import {
  GET_CHATBOT_RESPONSE_REQUEST,
  GET_CHATBOT_RESPONSE_SUCCESS,
  GET_CHATBOT_RESPONSE_FAILURE,
  CLEAR_CHATBOT_HISTORY
} from '../actionTypes';

const initialState = {
  response: null,
  loading: false,
  error: null
};

export default function chatbotReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CHATBOT_RESPONSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_CHATBOT_RESPONSE_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload
      };
    case GET_CHATBOT_RESPONSE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case CLEAR_CHATBOT_HISTORY:
      return {
        ...initialState
      };
    default:
      return state;
  }
}
